import React, {useState} from "react";
import BarekamInputMultilingual from "../../../../../../pages/components/input-multilingual/barekam-input-multilingual";
import {DialogContent, Grid} from "@mui/material";
import {Message, MessageSections} from "../../../../../../pages/components/message/message";
import {StandardDialogFooter} from "../../../../../../pages/components/dialogs/standard-dialog/standard-dialog";
import {getMessage} from "../../../../../../pages/shared/helper-functions";
import {useAppSelector} from "../../../../../../redux/store";
import {BarekamSelect} from "../../../../../../pages/components/select/select";
import {BarekamMenuItem, SelectedBarekamMenuItem} from "../../../../../../pages/components/select/styled/orders";
import {AxiosError} from "axios";
import {mapValidationErrors} from "../../../../../../pages/user/settings/personal-info/personal-info.service";
import {CityModel} from "../../../../../../pages/shared/models/cityModel";
import cityService from "../../../../../../services/city-service";

const EditCity = ({cityData, onCancel}: {cityData: CityModel, onCancel: () => void}) => {
    const {provinces} = useAppSelector(state => state.staticDataReducer);
    const [modifiedCity, setModifiedCity] = useState(cityData);
    const [errors, setErrors] = useState<{ [key: string]: string }>({});
    const {messageCache, languageId} = useAppSelector(state => state.messagesReducer);

    function handleChange(field: 'name' | 'province', value: any) {
        setModifiedCity(prevState => {
            if (field === 'province') {
                const province = provinces.find(province => province.provinceId === value);

                if (province) {
                    prevState[field] = province;
                }
            } else {
                prevState[field] = value;
            }

            return {...prevState}
        })
    }

    function validateData() {
        const errors = {} as {[key: string]: string};

        if (!modifiedCity.name || Object.keys(modifiedCity.name).length < 1) {
            errors['name'] = 'required';
        }
        if (!modifiedCity.province) {
            errors['province'] = 'required';
        }
        return errors;
    }

    function handleSave() {
        const errors = validateData();
        setErrors(errors);

        if (Object.keys(errors).length === 0) {
            if (modifiedCity.cityId) {
                cityService.editCity(modifiedCity.cityId, modifiedCity)
                    .then(() => onCancel())
                    .catch(reason => {
                        if (reason instanceof AxiosError) {
                            setErrors(mapValidationErrors(reason));
                        }
                    });
            } else {
                cityService.createCity(modifiedCity)
                    .then(() => onCancel())
                    .catch(reason => {
                        if (reason instanceof AxiosError) {
                            setErrors(mapValidationErrors(reason));
                        }
                    });
            }
        }
    }

    return (
        <>
            <DialogContent>
                <Grid container rowSpacing={'1rem'} columnSpacing={'1rem'}>
                    <BarekamInputMultilingual multilingualText={modifiedCity.name || {}}
                                              labelKey={'name'}
                                              field={'name'}
                                              onChange={(name) => handleChange('name', name)}
                                              errors={errors}/>

                    <Grid item xs={12}>
                        <BarekamSelect
                            variant={'outlined'}
                            label={getMessage('province', MessageSections.MAIN, messageCache, languageId)}
                            value={modifiedCity?.province?.provinceId || ''}
                            onChange={(value) => handleChange('province', value.target.value)}
                            type={"standard"}
                            error={!!errors['province']}
                            errorMessage={errors['province'] && getMessage(errors['province'], MessageSections.MAIN, messageCache, languageId)}>
                            {provinces.map((province, index) => {
                                if (province.provinceId === modifiedCity?.province?.provinceId) {
                                    return (
                                        <SelectedBarekamMenuItem value={province.provinceId}
                                                                 key={index}>
                                            {province.name[languageId]}
                                        </SelectedBarekamMenuItem>
                                    )
                                } else {
                                    return (
                                        <BarekamMenuItem value={province.provinceId}
                                                         key={index}>
                                            {province.name[languageId]}
                                        </BarekamMenuItem>
                                    );
                                }
                            })}
                        </BarekamSelect>
                    </Grid>
                </Grid>
            </DialogContent>

            <StandardDialogFooter onCancel={() => onCancel()}
                                  onSave={() => handleSave()}
                                  saveLabel={<Message messageKey={'save'} sectionId={MessageSections.MAIN}/>}/>
        </>
    );
}

export default EditCity;